import React, { useState } from 'react';
import { ListGroup, Collapse } from 'react-bootstrap';
import { useAppSelector } from '../store/hooks';
import { Track } from '../types';

interface TrackLinksProps {
  tracks: Track[];
}

const TrackLinks: React.FC<TrackLinksProps> = ({ tracks }) => {
  const { selectedTrackId } = useAppSelector((state) => state.app.backingTrack);
  const { mode } = useAppSelector((state) => state.app);
  const [open, setOpen] = useState(false);

  // Only show in backing track mode
  if (mode !== 'backingTrack' || !selectedTrackId) {
    return null;
  }

  const currentTrack = tracks.find((t) => t.id === selectedTrackId);

  if (!currentTrack?.metadata.links || currentTrack.metadata.links.length === 0) {
    return null;
  }

  return (
    <div className="track-links mb-3">
      <button
        type="button"
        className="btn btn-link p-0 text-decoration-none d-flex align-items-center justify-content-between w-100 mb-3"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls="track-links-collapse"
        style={{ color: 'inherit' }}
      >
        <h5 className="mb-0">Resources & Links ({currentTrack.metadata.links.length})</h5>
        <span aria-hidden="true" style={{ transition: 'transform 0.2s', transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }}>
          ▶
        </span>
      </button>
      <Collapse in={open}>
        <div id="track-links-collapse">
          <ListGroup className="mt-2">
            {currentTrack.metadata.links.map((link, index) => (
              <ListGroup.Item
                key={index}
                action
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center"
              >
                <i className="bi bi-link-45deg me-2"></i>
                {link.title}
                <i className="bi bi-box-arrow-up-right ms-auto small text-muted"></i>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </Collapse>
    </div>
  );
};

export default TrackLinks;
